"use client";
import React, { useRef, useMemo } from "react";
import Image from "next/image";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Client1 from "../../../public/assets/client/client1.png";
import Client2 from "../../../public/assets/client/client2.png";
import Client3 from "../../../public/assets/client/client3.png";
import Client4 from "../../../public/assets/client/client4.png";
import Client5 from "../../../public/assets/client/client5.png";

gsap.registerPlugin(ScrollTrigger);

const clientImages = [Client1, Client2, Client3, Client4,Client5];

const Clients = () => {
  const sectionRef = useRef(null);

  const logoRefs = useMemo(
    () => clientImages.map(() => React.createRef<HTMLDivElement>()),
    []
  );

  useGSAP(
    () => {
      logoRefs.forEach((ref, i) => {
        gsap.fromTo(
          ref.current,
          { y: 50, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 0.8,
            delay: i * 0.2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: ref.current,
              start: "top 90%",
              toggleActions: "play none none reverse",
            },
          }
        );
      });
    },
    { scope: sectionRef }
  );

  return (
    <section className="bg-white py-[100px]" ref={sectionRef}>
      <div className="container mx-auto">
        <h2 className="text-4xl font-bold mb-10 text-center text-[#282930]">
          Our <span className="red-gradient-text">Clients</span>
        </h2>
        <div className="grid grid-cols-2 xl:grid-cols-5 md:grid-cols-2  gap-6 px-4 md:px-0">
          {clientImages.map((img, i) => (
            <div
              key={i}
              ref={logoRefs[i]}
              className="border border-gray-200 rounded-lg p-4 bg-white transition-all duration-300 hover:scale-105"
            >
              <Image
                src={img}
                alt={`client-${i}`}
                loading="lazy"
                className="mx-auto"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
